import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getTravelReasonSlice = createSlice({
  name: "getTravelReason",
  initialState,
  reducers: {
    getTravelReasonStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getTravelReasonSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getTravelReasonFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getTravelReasonStart,
  getTravelReasonSuccess,
  getTravelReasonFailure,
  clearError,
  clearMessage,
} = getTravelReasonSlice.actions;

export default getTravelReasonSlice.reducer;
